/* istanbul ignore file: Excluded from coverage; this file configures Chakra UI styles, with no custom logic to test */
import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { colors } from '../foundations/colors';
import { typography } from '../foundations/typography';

const tableStyleConfigHelpers = createMultiStyleConfigHelpers(tableAnatomy.keys);

export const Table = tableStyleConfigHelpers.defineMultiStyleConfig({
  variants: {
    // targets the available invoices table shown in Order Form V2's Must Pay modal
    mustPayInvoiceTable: tableStyleConfigHelpers.definePartsStyle(({ colorMode }) => {
      return {
        table: {
          backgroundColor: colors.background.container[colorMode],
        },
        tr: {
          p: '0',
          borderTop: '1px',
          borderColor: colors.border.transparent[colorMode],
          // `first-of-type` instead of `first-child` to get rid of console warning
          '&:first-of-type': {
            borderTop: 'none',
          },
        },
        th: {
          ...typography.textStyles.body,
          color: colors.text.secondary[colorMode],
          textTransform: 'initial',
          letterSpacing: 'initial',
          px: '1.5rem',
          pb: '0.875rem',
          pt: '1.125rem',
          '&[data-is-numeric=true]': {
            textAlign: 'end',
          },
        },
        td: {
          ...typography.textStyles.body,
          p: '0',
          '&[data-is-numeric=true]': {
            textAlign: 'end',
          },
        },
        thead: {
          position: 'sticky',
          top: '0',
          backgroundColor: colors.background.container[colorMode],
          zIndex: '1',
        },
        tfoot: {
          borderTop: '1px',
          borderColor: colors.border.transparent[colorMode],
        },
      };
    }),
    // Targets the table on the v2 Order Form, which is the products table
    productsTable: tableStyleConfigHelpers.definePartsStyle(({ colorMode }) => {
      return {
        table: {
          backgroundColor: colors.background.container[colorMode],
        },
        tr: {
          p: '0.25rem',
          borderTop: '1px',
          borderColor: colors.border.transparent[colorMode],
          // `first-of-type` instead of `first-child` to get rid of console warning
          '&:first-of-type': {
            borderTop: 'none',
          },
        },
        th: {
          ...typography.textStyles.caption,
          color: colors.text.secondary[colorMode],
          textTransform: 'initial',
          letterSpacing: 'initial',
          px: '0.75rem',
          py: '0.75rem',
          '&[data-is-numeric=true]': {
            textAlign: 'end',
          },
        },
        td: {
          ...typography.textStyles.body,
          px: '0.75rem',
          py: '0.375rem',
          '&[data-is-numeric=true]': {
            textAlign: 'end',
          },
        },
        thead: {
          borderBottom: '1px',
          borderColor: colors.border.transparent[colorMode],
        },
        tfoot: {
          borderTop: '1px',
          borderColor: colors.border.transparent[colorMode],
        },
      };
    }),
  },
});
